import { supabase } from '@/integrations/supabase/client';

const fomoOfficialCommunities = [
  {
    name: 'art',
    display_name: 'Art',
    description: 'A community for artists, creators, and art enthusiasts',
    icon: '🎨',
    color: '#FF6B6B',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  },
  {
    name: 'photography',
    display_name: 'Photography',
    description: 'Share and discover stunning photography',
    icon: '📸',
    color: '#4ECDC4',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  },
  {
    name: '3d',
    display_name: '3D Art',
    description: '3D modeling, rendering, and digital sculptures',
    icon: '🎮',
    color: '#95E1D3',
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  },
  {
    name: 'anime',
    display_name: 'Anime',
    description: 'Anime, manga, and Japanese culture',
    icon: '🌸',
    color: '#F38181',
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  },
  {
    name: 'cinema',
    display_name: 'Cinema',
    description: 'Movies, films, and cinematic discussions',
    icon: '🎬',
    color: '#AA96DA',
    gradient: 'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  },
  {
    name: 'gaming',
    display_name: 'Gaming',
    description: 'Video games, esports, and gaming culture',
    icon: '🎮',
    color: '#8FD3F4',
    gradient: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
    is_fomo_official: true,
    is_auto_generated: false
  }
];

export async function initializeFomoCommunities() {
  console.log('🚀 Initializing FOMO Official Communities...');
  
  try {
    for (const community of fomoOfficialCommunities) {
      const { data, error } = await supabase
        .from('communities')
        .upsert(community, {
          onConflict: 'name',
          ignoreDuplicates: false
        })
        .select();
      
      if (error) {
        console.error(`❌ Error inserting ${community.name}:`, error);
      } else {
        console.log(`✅ Initialized community: ${community.display_name}`);
      }
    }
    
    console.log('🎉 All FOMO Official Communities initialized successfully!');
    return true;
  } catch (error) {
    console.error('❌ Unexpected error:', error);
    return false;
  }
}

// Export to window for easy browser console access
if (typeof window !== 'undefined') {
  (window as any).initializeFomoCommunities = initializeFomoCommunities;
}
